import { Download, GridCell } from '@uhg-uicl/ui-core/dist';
import { LeftNavDirectories } from './types';
import { IRR_ISR_EOR, IRR_OTHER, SUPPLEMENTAL_FILES } from './utils';

export const VIEW_GRID_COLUMNS = new Set([
  {
    dataName: 'download',
    text: <GridCell cellType="icon" data={{ icon: Download }} />,
    align: 'left',
    cellType: 'custom',
    isHeaderTruncated: true,
    headerWidth: 40,
    sortable: false,
  },
  {
    dataName: 'name',
    text: 'Name',
    isHeaderTruncated: true,
    headerWidth: 500,
    sortable: false,
  },
  {
    dataName: 'lastModified',
    text: 'Last Modified',
    sortable: false,
    isSorted: 1,
    isHeaderTruncated: true,
    headerWidth: 160,
  },
  {
    dataName: 'size',
    text: 'Size',
    isHeaderTruncated: true,
    headerWidth: 90,
    sortable: false,
  },
]);

export enum ActionTypesDocuments {
  SET_SELECTED_FOLDER_KEY_PATH = 'SET_SELECTED_FOLDER_KEY_PATH',
  SET_DOCUMENT_DIRECTORY_LIST = 'SET_DOCUMENT_DIRECTORY_LIST',
  TOGGLE_IS_DOCUMENT_DELETE_LOADING = 'TOGGLE_IS_DOCUMENT_DELETE_LOADING',
  TOGGLE_IS_DOCUMENT_LOADING = 'TOGGLE_IS_DOCUMENT_LOADING',
  TOGGLE_REFRESH_CACHE = 'TOGGLE_REFRESH_CACHE',
  TOGGLE_IS_DOCUMENT_DOWNLOAD_LOADING = 'TOGGLE_IS_DOCUMENT_DOWNLOAD_LOADING',
  TOGGLE_IS_DOCUMENT_UPLOAD_LOADING = 'TOGGLE_IS_DOCUMENT_UPLOAD_LOADING',
}

export const testDirectories: LeftNavDirectories[] = [
  {
    name: 'Aetna ACAS [365]',
    subDirectories: [
      {
        name: IRR_ISR_EOR,
        subDirectories: [],
        keyPath: 'Aetna ACAS [365]/irr-isr-eor',
      },
      {
        name: IRR_OTHER,
        subDirectories: [],
        keyPath: 'Aetna ACAS [365]/irr-other',
      },
      {
        name: SUPPLEMENTAL_FILES,
        subDirectories: [],
        keyPath: 'Aetna ACAS [365]/files',
      },
    ],
    keyPath: 'Aetna ACAS [365]',
  },
  {
    name: 'Blue Cross of Idaho [274]',
    subDirectories: [
      {
        name: IRR_ISR_EOR,
        subDirectories: [],
        keyPath: 'Blue Cross of Idaho [274]/irr-isr-eor',
      },
      {
        name: IRR_OTHER,
        subDirectories: [],
        keyPath: 'Blue Cross of Idaho [274]/irr-other',
      },
      {
        name: SUPPLEMENTAL_FILES,
        subDirectories: [],
        keyPath: 'Blue Cross of Idaho [274]/files',
      },
    ],
    keyPath: 'Blue Cross of Idaho [274]',
  },
];

export const docUploadModalMessages = {
  uploadDocument: 'Upload a Document',
  fileTypeError: 'Uploading of this file type is not allowed.',
  fileSizeError: 'File cannot exceed 100MB in size.',
  fileError: 'Please select a file.',
  enterANote: 'Enter a Note.',
  upload: 'Upload',
  cancel: 'Cancel',
  note: 'Note',
  inProgress: 'Please wait, in progress.',
};
